module.exports = __webpack_public_path__ + "static/img/654_phase_function_Paper_PointsHejduk_Prediction.c8cf578.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/654_phase_function_Paper_PointsHejduk_Prediction.png
// module id = /vN4
// module chunks = 0